import { Component } from '@angular/core';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-target-renderer',
    template: `
        <span>
            <img [src]="imageSource" style="height:20px; ">    {{value}}
        </span>
    `
})

export class TargetCellRenderer implements INoRowsOverlayAngularComp {

    imageSource: string;
    value: any;

    agInit(params): void {
        let image;
        //const image = params.value === 'Oil' ? 'Oil.png' : 'Gas.png';
        if(params.value === "Oil") {
            image = 'Oil.png';
        } else if(params.value === "Gas") {
            image = 'Gas.png';
        } else {
            image = 'OilGas.png';
        }
        this.imageSource = `./assets/images/${image}`
        this.value = params.value;
    }
}